import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { gql } from '@apollo/client';
import apolloClient from '../../graphql/apollo-client';
import { GET_NOTICES } from '../../graphql/queries';

const NoticePage: React.FC = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const [notices, setNotices] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await apolloClient.query({
          query: gql`${GET_NOTICES}`,
          fetchPolicy: 'network-only',
        });
        setNotices(res.data?.getNotices?.notices || []);
      } catch (err) {
        console.error('Failed to fetch notices:', err);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 py-6">
      <h1 className="text-xl font-bold text-gray-900 mb-2">{t('notice.title')}</h1>
      <hr className="border-gray-200 mb-6" />

      {loading ? (
        <div className="text-center py-8 text-gray-400">{t('loading')}</div>
      ) : notices.length === 0 ? (
        <div className="text-center py-8 text-gray-400">{t('notice.empty')}</div>
      ) : (
        <div className="space-y-0">
          {notices.map((notice) => (
            <div
              key={notice.noticeId}
              onClick={() => navigate(`/notice/${notice.noticeId}`)}
              className="border-b border-gray-100 py-4 cursor-pointer hover:bg-gray-50 px-2 -mx-2 rounded transition-colors"
            >
              <div className="flex items-center gap-3 mb-1">
                <span className="px-2 py-0.5 text-xs font-medium bg-blue-100 text-blue-700 rounded">
                  {notice.noticeType || '공지'}
                </span>
                <span className="text-sm font-bold text-gray-900 flex-1 truncate">{notice.title}</span>
                <span className="text-xs text-gray-400 flex-shrink-0">
                  {notice.createdAt?.slice(0, 10)}
                </span>
              </div>
              <p className="text-sm text-gray-500 truncate pl-[calc(2rem+12px)]">
                {notice.content}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NoticePage;
